import React, {useState, useEffect, lazy, useContext, useRef} from "react";

import og_image from './../../img/og-im.jpg'

import Header from './Header';
import Detailed from "./Detailed";
import { Outlet, useLocation, useParams, useNavigate, useSearchParams, NavLink} from "react-router-dom";
import {PointsContext} from "../../pages/MainPage";
import {useMap} from "react-map-gl";

import './MainView.css'

import {MapIcon} from '@heroicons/react/solid'
import {CollectionIcon} from '@heroicons/react/outline'
import {ArchiveIcon} from '@heroicons/react/outline'

import MapView from "./MapView";
// const MapView = lazy(() => import("./MapView"));

import {CSSTransition} from 'react-transition-group';
import {Popover, Transition} from '@headlessui/react'

import {LanguageContext} from "../../App";

import {
    addWeeks,
    endOfDay,
    startOfDay,
    parse,
    format
} from 'date-fns';

import {DateRangePicker} from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {defaultStaticRanges, defaultInputRanges, defaultStaticRangesEn} from '../../helpers/daterangedef'
import {ru, enUS} from "date-fns/locale";

import {isMobile} from 'react-device-detect';
import {getIconById} from "../dataIcons";
import * as moment from "moment";
import {Helmet} from "react-helmet";


const cf = require('contentful');
const client = cf.createClient({
    space: 'wvu4fbse6d4b',
    accessToken: process.env.REACT_APP_CF_KEY,
});


// last week initial range
const initialRange = {
    startDate: startOfDay(addWeeks(new Date(), -1)),
    endDate: new Date(),
    key: 'selection',
}

// modify data to app usage
const point_modify = (entry) => {
    let protest_type = 'Протест'
    let protest_type_id = 0
    let slug = ''

    if (entry.fields.protest_type) {
        protest_type = entry.fields.protest_type.fields.title
        protest_type_id = entry.fields.protest_type.fields.id
    } else {
        protest_type = 'Протест'
        protest_type_id = 0
    }
    if (entry.fields.slug) {
        slug = entry.fields.slug
    } else {
        slug = ''
    }

    return {
        geometry: {
            type: "Point",
            coordinates: [
                entry.fields.geo.lon,
                entry.fields.geo.lat
            ]
        },
        properties: {
            id: entry.sys.id,
            title: entry.fields.title,
            text: entry.fields.text,
            type: entry.fields.type,
            url: entry.fields.url,
            datetime: entry.fields.datetime,
            protest_type: protest_type,
            protest_type_id: protest_type_id,
            slug: slug,
            tg_widget: entry.fields.tg_widget,
        },
        type: "Feature"
    }
}


const MainView = () => {
    const location = useLocation();
    const params = useParams()
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const prevslug = useRef();

    const [height, setHeight] = useState(window.innerHeight)

    const handleResizeWindow = () => setHeight(window.innerHeight);

    useEffect(()=> {
        window.addEventListener("resize", handleResizeWindow);
        return ()=>{
            window.removeEventListener("resize", handleResizeWindow);
        }
    })

    // Range state
    const [range, setRange] = useState(searchParams.get('start') ? {
        startDate: parse(searchParams.get('start'), 'dd-MM-yy', new Date()),
        endDate: endOfDay(parse(searchParams.get('end'), 'dd-MM-yy', new Date())),
        key: 'selection',
    } : initialRange);

    const [rangeSelection, setRangeSelection] = useState(range)

    const [isDetailed, setIsDetailed] = useState(false);
    // const [detailed, setDetailed] = useState({})


    const [clicked, setClicked] = useState({
        properties: {
            id: null
        }
    })
    const [isMobileSideBar, setIsMobileSideBar] = useState(false)

    const [pointsIsLoading, setPointsIsLoading] = useState(true)

    const parseData = (data) => JSON.stringify(data)

    const {points, setPoints} = useContext(PointsContext)
    const {language} = useContext(LanguageContext)
    const {main_map} = useMap();

    // map resize function
    const mapResize = () => {
        main_map.flyTo({center: [105.13, 64.17], zoom: 2});
    }


    // first fetch data function
    const fetchData = async () => {
        // console.log(language.name)
        let points = []

        try {
             const pointss = await client.getEntries({
                content_type: 'post',
                order: '-fields.datetime',
                limit: 1000,
                skip: 0,
                'locale': language.name === 'en' ? 'en-US':'ru',
                'fields.datetime[gt]': range.startDate,
                'fields.datetime[lt]': range.endDate,
            }).then(function (entries) {

                // todo pagination
                // console.log(entries)
                // console.log('total: ' + entries.total)

                const points = entries.items.map(function (entry) {
                    return point_modify(entry)
                });
                const total = entries.total
                return {points, total}
            })
            points = points.concat(pointss.points);
            if (pointss.total > 1000) {
                const pointss2 = await client.getEntries({
                    content_type: 'post',
                    order: '-fields.datetime',
                    limit: 1000,
                    skip: 1000,
                    'locale': language.name === 'en' ? 'en-US':'ru',
                    'fields.datetime[gt]': range.startDate,
                    'fields.datetime[lt]': range.endDate,
                }).then(function (entries) {

                    // todo pagination
                    // console.log(entries)
                    // console.log('total: ' + entries.total)

                    const points = entries.items.map(function (entry) {
                        return point_modify(entry)
                    });
                    const total = entries.total
                    return {points, total}
                })
                points = points.concat(pointss2.points);
            }

            return points
        } catch (e) {
            throw new Error(e)
        }

    }
    // catch ranges params
    useEffect(() => {
        // console.log('range ue')
        fetchData().then(res => {
            setPoints(res)
            setPointsIsLoading(false)
            xxx(res)
        }).catch(e => {    // xxx - after load function with points
            console.log('error fetch data')
            console.log(e)
            // todo add navigate to 404
        })

    }, [range])

    // after load xxx -> find point by url ...
    const xxx = (points) => {
        if (params.slug && points.length) {
            findPoints(points)
        }
    }

    // catch range link
    // catch backward
    useEffect(() => {
        //catch range link
        if (searchParams.get('start')) {
            let new_range = {
                startDate: parse(searchParams.get('start'), 'dd-MM-yy', new Date()),
                endDate: endOfDay(parse(searchParams.get('end'), 'dd-MM-yy', new Date())),
                key: 'selection',
            }
            if (parseData(range) !== parseData(new_range)) {
                setRangeSelection(new_range)
                setRange(new_range)
            }
        }
        // catch backward
        if (clicked.properties.slug !== params.slug) {
            if (!params.slug) {
                // if(prevslug.current !== params.slug) {
                //     navigate('/')
                //     setClicked({
                //         properties: {
                //             id: null
                //         }}
                //     )
                // }
            } else {
                const post = points.find((point) => point.properties.id === params.slug || point.properties.slug === params.slug)
                if (post) {
                    setClicked(post)
                }
            }
        }
        prevslug.current = params.slug
    }, [params])

    //setting found point to clicked and detailed
    const set_Detailed_add = (entry, add, points) => {
        // console.log('setdetadd')
        let post = entry
        if (add) {
            post = point_modify(post)
            setPoints([...points, post])
        }
        setClicked(post)
        setIsDetailed(true)
    }

    // find points by url function
    const findPoints = (points) => {
        // console.log(language.name)
        const post = points.find((item) => item.properties.id === params.slug || item.properties.slug === params.slug)
        if (post) {
            set_Detailed_add(post, false, points)
        } else {
            client.getEntries({
                content_type: 'post',
                'fields.slug': params.slug,
                'locale': language.name === 'en' ? 'en-US':'ru',

            }).then(function (entries) {
                if (entries.total === 0) {
                    client.getEntry(params.slug).then(function (entry) {
                        set_Detailed_add(entry, true, points)
                    }).catch(e => {
                        console.dir(e)
                        //todo add modal error not exist article
                    })
                } else {
                    set_Detailed_add(entries.items[0], true, points)
                }
            })

        }
    }

    // create refs for points sidebar
    const refs = points.reduce((point, value) => {
        point[value.properties.id] = React.createRef();
        return point;
    }, {});

    // scroll to post function
    const scrollToPost = (clicked) => {
        if (refs[clicked.properties.id].current) {
            refs[clicked.properties.id].current.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
            })
        }
    }

    const mobilesidebaropen = () => {
        setIsDetailed(false)
        setIsMobileSideBar(true)
        // clicked.properties.title && scrollToPost(clicked)
    }

    const mobilesidebarclose = () => {
        setIsDetailed(false)
        setIsMobileSideBar(false)
    }

    // Scroll to post on clicked change
    useEffect(() => {
        // console.log('clicked')
        if (!!clicked.properties.id) {
            if (clicked.properties.slug !== params.slug) {
                scrollToPost(clicked)
                navigate(`${clicked.properties.slug || clicked.properties.id}`)
            } else {
                // when open link with slug
                scrollToPost(clicked)
            }
        }
    }, [clicked])

    const handleSelect = (ranges) => {
        setRangeSelection({
            startDate: ranges.selection.startDate,
            endDate: endOfDay(ranges.selection.endDate),
            key: 'selection',
        })
    }

    const rangeSubmit = () => {
        setRange(rangeSelection)
        mapResize()
        if (language.name === 'en') {
            navigate('/en')
        } else {
            navigate('/')
        }
        // todo scroll to first item
        setClicked({
            properties: {
                id: null
            }
        })
    }


    const MiddleNav = () => {
        let active = false
        if (params.slug) {
            active = true
        } else {
            active = false
        }

        return (
            <nav className='w-full border-b bg-white h-16 flex items-stretch text-center'>
                <NavLink className={({isActive}) => isActive || active ?
                    "bg-gray-100 basis-1/2 flex flex-col justify-center" :
                    "basis-1/2 flex flex-col justify-center"}
                         to={language.name === 'en' ? '/en' : '/'}>
                    <CollectionIcon className='h-5'/>
                    <span className='text-sm'> {language.main_page.side_bar.navigation.news_list}</span>




                </NavLink>
                <NavLink className={({isActive}) => isActive ?
                    "bg-gray-100 basis-1/2 flex flex-col justify-center" :
                    "basis-1/2 flex flex-col justify-center"}
                         to='ranges'>
                    <ArchiveIcon className='h-5'/>
                    <span className='text-sm'>{language.main_page.side_bar.navigation.archive}</span>
                </NavLink>
            </nav>
        )
    }


    return (



        <div className='flex'>
                {
                    clicked.properties?.title ?
                        <Helmet>
                            <meta charSet="utf-8" />
                            <title>{'ReMap - ' + clicked.properties?.title}</title>
                            <meta name="description" content="Интерактивная карта с антивоенными протестами по всей России"/>

                            {/*Facebook Meta Tags*/}
                            {/*<meta property="og:url" content="https://remap-ru.com/"/>*/}
                            <meta property="og:type" content="website"/>
                            <meta property="og:title" content={clicked.properties?.title}/>
                            <meta property="og:description" content="Интерактивная карта с антивоенными протестами по всей России"/>
                            <meta property="og:image" content={og_image}/>
                        </Helmet>
                        :
                        <Helmet>
                            <meta charSet="utf-8" />
                            <title>ReMap - Хроника протестов в России</title>
                            <meta name="description" content="Интерактивная карта с антивоенными протестами по всей России"/>

                            {/*Facebook Meta Tags*/}
                            {/*<meta property="og:url" content="https://remap-ru.com/"/>*/}
                            <meta property="og:type" content="website"/>
                            <meta property="og:title" content='ReMap - Хроника протестов в России'/>
                            <meta property="og:description" content="Интерактивная карта с антивоенными протестами по всей России"/>
                            <meta property="og:image" content={og_image}/>
                        </Helmet>

                }



            <div className='relative flex flex-col'
                 style={isMobile ? {width: '100%', height} : {width: '71%', height}}
            >
                <Header/>
                <MapView points={points} clicked={clicked} setClicked={setClicked}/>

                <div className='absolute w-full'>
                    <div className='absolute top-16 left-0 m-5'>
                        <Popover className="relative">
                            {({open}) => (
                                <>
                                    <Popover.Button>
                                        <div
                                            className={'flex bg-white rounded-sm p-2 items-center' + (open ? ' bg-gray-100' : '')}>
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                 className="h-5 w-5 text-gray-700"
                                                 fill="none"
                                                 viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                                            </svg>
                                            <div className='text-sm px-2 text-gray-800'>
                                                {format(range.startDate, 'dd.MM')} - {format(range.endDate, 'dd.MM')}
                                            </div>
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                 className="h-5 w-5 text-gray-700"
                                                 fill="none"
                                                 viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round"
                                                      d="M19 9l-7 7-7-7"/>
                                            </svg>
                                        </div>

                                    </Popover.Button>

                                    <Transition
                                        enter="transition duration-100 ease-out"
                                        enterFrom="transform scale-95 opacity-0"
                                        enterTo="transform scale-100 opacity-100"
                                        leave="transition duration-75 ease-out"
                                        leaveFrom="transform scale-100 opacity-100"
                                        leaveTo="transform scale-95 opacity-0"
                                    >
                                        <Popover.Panel className="absolute z-10 mt-2">
                                            {({close}) => (
                                                <>
                                                    <DateRangePicker
                                                        locale={language.name === 'en' ? enUS : ru}
                                                        ranges={[rangeSelection]}
                                                        onChange={handleSelect}
                                                        staticRanges={language.name === 'ru' ? defaultStaticRanges: defaultStaticRangesEn}
                                                        inputRanges={defaultInputRanges}
                                                    />
                                                    <div className='bg-white text-right '>
                                                        <button onClick={async () => {
                                                            await rangeSubmit()
                                                            close()
                                                        }}
                                                                className='right-1 p-2 text-sm rounded-md bg-gray-200 mb-2 mr-2 hover:bg-gray-300'>
                                                            {language.main_page.apply}
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </Popover.Panel>
                                    </Transition>
                                </>
                            )}
                        </Popover>
                    </div>
                    <div
                        className='absolute top-16 right-0 rounded-full bg-white p-2 m-5 hover:bg-gray-100 cursor-pointer'
                        onClick={() => mapResize()}
                    >
                        <MapIcon className="w-6 h-6"/>
                    </div>
                </div>


                {
                    isMobile &&
                    <div className='absolute bottom-0 z-30 w-full'>
                        {clicked.properties.title && !isDetailed && !isMobileSideBar &&
                            <div className='w-full bg-white p-4'>
                                <div className='flex justify-between text-sm text-gray-500'>
                                    <div className='flex items-center'>
                                        <img alt='Тип протеста' className='rounded-full bg-red-600 '
                                             style={{height: '24px', width: '24px'}}
                                             src={getIconById(clicked.properties.protest_type_id)}/>
                                        <p className='pl-2'>{clicked.properties.protest_type}</p>
                                    </div>
                                    <p className=''>{moment(clicked.properties.datetime).format('DD.MM H:mm')}</p>
                                </div>
                                <h1 className='pt-3 text-sm'>{clicked.properties.title}</h1>
                            </div>
                        }

                        <div className='bg-white border-t'>
                            <div className='flex justify-between text-sm text-center px-4 py-2'>

                                { (isMobileSideBar && location.pathname === '/ranges') || location.pathname === '/en/ranges' ?
                                    <div className="basis-1/3 flex flex-col justify-center"
                                         onClick={mobilesidebarclose}>
                                        <MapIcon className="h-5"/>
                                        <span className='text-xs'>{language.main_page.side_bar.navigation.map}</span>
                                    </div>
                                    :
                                    <NavLink onClick={mobilesidebaropen}
                                             className="basis-1/3 flex flex-col justify-center"
                                             to='ranges'>
                                        <ArchiveIcon className='h-5'/>
                                        <span className='text-xs'>{language.main_page.side_bar.navigation.archive}</span>
                                    </NavLink>
                                }

                                {
                                    clicked.properties.title &&
                                    <>
                                        {
                                            isDetailed ?
                                                <div onClick={() => setIsDetailed(false)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 m-auto"
                                                         fill="none"
                                                         viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                        <path strokeLinecap="round" strokeLinejoin="round"
                                                              d="M19 13l-7 7-7-7m14-8l-7 7-7-7"/>
                                                    </svg>
                                                    <span className='text-xs'>{language.main_page.side_bar.navigation.less}</span>
                                                </div>
                                                :
                                                <div onClick={() => setIsDetailed(true)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 m-auto"
                                                         fill="none"
                                                         viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                        <path strokeLinecap="round" strokeLinejoin="round"
                                                              d="M5 11l7-7 7 7M5 19l7-7 7 7"/>
                                                    </svg>
                                                    <span className='text-xs'>{language.main_page.side_bar.navigation.more}</span>
                                                </div>
                                        }
                                    </>
                                }
                                {isMobileSideBar && location.pathname !== '/ranges' && location.pathname !== '/en/ranges' ?
                                    <div className="basis-1/3 flex flex-col justify-center"
                                         onClick={mobilesidebarclose}>
                                        <MapIcon className="h-5"/>
                                        <span className='text-xs'>{language.main_page.side_bar.navigation.map}</span>
                                    </div>
                                    :
                                    <NavLink onClick={mobilesidebaropen}
                                             className="basis-1/3 flex flex-col justify-center"
                                             to={language.name === 'en' ? '/en' : '/'}>
                                        <CollectionIcon className='h-5'/>
                                        <span className='text-xs'>{language.main_page.side_bar.navigation.news_mob_list}</span>
                                    </NavLink>
                                }
                            </div>
                        </div>

                    </div>
                }
            </div>



            {!isMobile &&
                <main className="flex flex-col h-screen"
                      style={{width: '29%'}}
                >
                    <MiddleNav/>
                    <Outlet context={[clicked, setClicked, refs, setIsDetailed, range, pointsIsLoading]}/>
                </main>

            }
            {isMobile && isMobileSideBar &&
                <main className="absolute w-full"
                    style={{height}}
                >
                    <Header/>
                    <Outlet context={[clicked, setClicked, refs, setIsDetailed, range, pointsIsLoading]}/>
                </main>
            }


            {isMobile ?
                <>
                    <CSSTransition in={isDetailed} timeout={500} classNames="mdet-dialog-back" unmountOnExit>
                        <div className='fixed top-0 left-0 bg-gray-500/40 z-10 w-full h-screen'/>
                    </CSSTransition>
                    <CSSTransition in={isDetailed} timeout={300} classNames="mdet-dialog" unmountOnExit>
                        <Detailed clicked={clicked} setIsDetailed={setIsDetailed}/>
                    </CSSTransition>
                </>
                :
                <>
                    <CSSTransition in={isDetailed} timeout={500} classNames="det-dialog-back" unmountOnExit>
                        <div className='fixed top-0 left-0 bg-gray-500/40 z-10 w-full h-screen'/>
                    </CSSTransition>
                    <CSSTransition in={isDetailed} timeout={300} classNames="det-dialog" unmountOnExit>
                        <Detailed clicked={clicked} setIsDetailed={setIsDetailed}/>
                    </CSSTransition>
                </>
            }


        </div>
    )
}

export default MainView